import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { AdminHeaderComponent } from './components/admin-header/admin-header.component';
import { SuccessComponent } from './modals/success/success.component';
import { ErrorComponent } from './modals/error/error.component';
import { ResponseComponent } from './modals/response/response.component';
import { LoadingSpinnerComponent } from './modals/loading-spinner/loading-spinner.component';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AssignStudentScheduleConfirmComponent } from './modals/assign-student-schedule-confirm/assign-student-schedule-confirm.component';
import { VerifyMasterComponent } from './modals/verify-master/verify-master.component';
import { ConfirmTransmitComponent } from './modals/confirm-transmit/confirm-transmit.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    AdminHeaderComponent,
    SuccessComponent,
    ErrorComponent,
    ResponseComponent,
    LoadingSpinnerComponent,
    AssignStudentScheduleConfirmComponent,
    VerifyMasterComponent,
    ConfirmTransmitComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    MatDatetimepickerModule,
    MatNativeDatetimeModule,
    MatDatepickerModule,
    NgxMatTimepickerModule.setLocale('en-GB'),
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    AdminHeaderComponent,
  ]
})
export class SharedModule { }
